import type { FluxErrorEntityErrorCodes } from '../types.js';

export const DeadlineErrorCodes = {
  DeadlineNotFound: {
    code: 'deadline/not-found',
    message: 'O prazo especificado não foi encontrado.',
    explanation: 'O prazo que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'deadline'>;
